import styled from 'styled-components';

export const HeaderContainer = styled.div`
  padding: 1.5rem 1.5rem 3rem 1.5rem;
  background-color: ${({ theme }) => theme.colors.white};
  font-family: ${({ theme }) => theme.fonts.workSans};

  & > button {
    margin-bottom: 1rem;
  }
`;

export const TableContainer = styled.div`
  padding: 1rem;
  background-color: ${({ theme }) => theme.colors.gray8};
`;

export const ActionsContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  column-gap: 1rem;
  padding: 3rem 1rem;
  background-color: ${({ theme }) => theme.colors.white};

  & > button {
    width: 23rem;
  }
`;
